import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "./dashboardApi";

export function useDashboardMetrics(companyId?: string, days: number = 30) {
  return useQuery({
    queryKey: ["dashboard", "metrics", companyId, days],
    queryFn: () => dashboardApi.getDashboardMetrics(companyId, days),
    refetchInterval: 30000, // Refetch every 30 seconds for near real-time data
    staleTime: 20000, // Consider data stale after 20 seconds
  });
}
